import { render, staticRenderFns } from "./add_space_source.vue?vue&type=template&id=1f0f567c&scoped=true&"
import script from "./add_space_source.vue?vue&type=script&lang=js&"
export * from "./add_space_source.vue?vue&type=script&lang=js&"
import style0 from "./add_space_source.vue?vue&type=style&index=0&id=1f0f567c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0f567c",
  null
  
)

export default component.exports